export default {
  ACCOUNTS_URL: window.__CONFIG__.ACCOUNTS_URL,
  CHANGE_LANGUAGE_PATH: window.__CONFIG__.CHANGE_LANGUAGE_PATH,
  FILES_URL: window.__CONFIG__.FILES_URL,
  DEV_PORTAL_URL: window.__CONFIG__.DEV_PORTAL_URL,
  CLIENT_VERSION: window.__CONFIG__.CLIENT_VERSION,
  SALES_TAX_ENABLED: window.__CONFIG__.SALES_TAX_ENABLED,
  HELP_LINK: window.__CONFIG__.HELP_LINK,
  RECAPTCHA_KEY: window.__CONFIG__.RECAPTCHA_KEY,
  API_USAGE_URL: window.__CONFIG__.API_USAGE_URL,
  SCRIPT_NAME: process.env.NODE_ENV === 'development' ? '/' : '/search/',
  SI_DOCS_LINK: window.__CONFIG__.SI_DOCS_LINK,
  MAX_DAYS_TO_DISPLAY_SI_DOCS_BANNER: window.__CONFIG__.MAX_DAYS_TO_DISPLAY_SI_DOCS_BANNER,
  SI_DOCS_BANNER_ENABLED: window.__CONFIG__.SI_DOCS_BANNER_ENABLED,
};
